import ClaimType from '../model/ClaimType';
import m from './module';
import { getProvisionalIdentifierForType } from '../util';

const type = 'PositionClaimType';

class PositionClaimTypeService {
  constructor($q, $log, ClaimCategoryService, DataSyncService) {
    this.$q = $q;
    this.$log = $log;
    this.ClaimCategoryService = ClaimCategoryService;
    this.DataSyncService = DataSyncService;
    this._objectsByIdMap = {};
  }

  create(data) {
    data = data || {};
    let promises = [];

    if (!data.id) {
      data.id = getProvisionalIdentifierForType("positionclaimtype");
      this.$log.warn("Attempt to create PositionClaimType with no ID. Setting provisional ID:", data.id);
    }

    if (data.claim_categories_id) {
      promises.push(
        this.ClaimCategoryService
          .getById(data.claim_categories_id)
          .then(claimCategory => data.category = claimCategory)
      )
    }

    return this.$q.all(promises)
      .then(() => {
        const model = new ClaimType(data);
        return this.DataSyncService.setObjectById(type, data.id, model);
      });
  }

  getById(id) {
    return this.DataSyncService.getLocalObjectById(type, id);
  }
}

export default PositionClaimTypeService;

m.service('PositionClaimTypeService', PositionClaimTypeService);
